import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import GroupLayer from "../../components/message/GroupLayer";

const GroupPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Group Message" />
      <GroupLayer />
    </MasterLayout>
  );
};

export default GroupPage;
